
/* injects from baggage-loader */

'use strict';
import DialogAlertController from '../alert/alert.controller';

import mapImg from '_images/trophies/island-map.png';
import pageBookImg from '_images/trophies/page-book.png';
import lifeImg from '_images/trophies/life.png';

export default class DialogTrophyController extends DialogAlertController{
    constructor($log, $rootScope, $timeout, Trophies) {
        'ngInject';

        super($log, $rootScope);

        this.$log = $log;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        
        this.Trophies = Trophies;

        this.mapImg = mapImg;
        this.pageBookImg = pageBookImg;
        this.lifeImg = lifeImg;

        this.state = {
            step: 0
        }
    }      

    $onInit(){
        super.$onInit();

        if(!this.resolve.hasCarousel) return;

        this.$timeout(() => {
            $('.trophies-carousel').slick({
                infinite: false,
                draggable: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            });
        });
    }

    toNextStep(){
        this.state.step += 1;
        $('.trophies-carousel').slick('slickNext');
    }  

    isLastSentence(){
        return this.state.step === ( this.resolve.texts.length - 1 )
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/trophy/trophy.controller.js